<template>
  <div>
    <div v-if="userNetworkUsersList.length" class="chat-recipient">
      <div class="recipient">
        <div class="person-cont">
          <div v-if="!privateChatTarget" class="person"></div>
          <person
            v-if="privateChatTarget"
            :person="privateChatTargetUser"
            :options="{ actions: true, inlineActions: false }"
          ></person>

          <div class="chat-filter">
            <div class="input-group">
              <div class="input-group-btn ctrl-recipient">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-default btn-private dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span v-if="!privateChatTarget" class="noneselected">Select recipient from Contacts...</span>
                    <i class="ar-icon icon-caret-down-light" aria-hidden="true"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <template v-for="user in filterPublicGalleryUser">
                      <li
                        @click="filterUser(user)"
                        :key="'chatTarget-' + user.userUUID"
                        v-if="!privateChatTarget || (privateChatTarget && privateChatTarget.userUUID !== user.userUUID)"
                      >
                        <a href="javascript:void(0);">
                          <person
                            :person="user"
                            :options="{ company: true, title: true, actions: false, inlineActions: false }"
                          ></person>
                        </a>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="clear-recipient">
            <a v-show="privateChatTarget" href="javascript:void(0);" @click="clearFilter" class="link-clear"
              ><i class="ar-icon icon-times-light" aria-hidden="true"></i
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!privateChatTarget" class="chat-filters">
      <div class="title"><b>Show from:</b></div>
      <div class="key-node my">
        <label class="styled-cb">
          <span class="filter-name"> Contacts ({{ myNetworkFilterCounter }})</span>
          <input type="checkbox" v-model="myNetworkFilter" />
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="key-node other">
        <label class="styled-cb">
          <span class="filter-name">Others ({{ otherFilterCounter }})</span>
          <input type="checkbox" v-model="otherFilter" />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { CHAT_MODES, USER_CONNECTIONS_STATUSES } from "@/helpers/constants";
import Person from "@/components/DigitalEvent/RoomList/Room/People/Person";

export default {
  name: "ChatFilter",
  components: {
    person: Person
  },
  computed: {
    ...mapState("chat", {
      privateChatTarget: "privateChatTarget"
    }),
    ...mapGetters({
      myNetworkFilterCounter: "chat/networkMessagesCounter",
      otherFilterCounter: "chat/otherMessagesCounter",
      publicTable: "tables/publicTable",
      publicTableUsers: "tables/publicTableUsers"
    }),
    myNetworkFilter: {
      get() {
        return this.$store.state.chat.privateChatFilters.NETWORK;
      },
      set(value) {
        this.$store.commit("chat/updatePrivateChatFilters", {
          type: "NETWORK",
          value
        });
      }
    },
    otherFilter: {
      get() {
        return this.$store.state.chat.privateChatFilters.OTHER;
      },
      set(value) {
        this.$store.commit("chat/updatePrivateChatFilters", {
          type: "OTHER",
          value
        });
      }
    },
    /**
     * Active user connections
     * @return {Object[]}
     * @private
     */
    _connections() {
      return this.$store.state.users.userConnections.filter(
        connection => connection.connectionStatus === USER_CONNECTIONS_STATUSES.ACTIVE
      );
    },
    /**
     * Get list of user models from current user network connections
     * @return {Object[]}
     */
    userNetworkUsersList() {
      return this._connections.map(connection => {
        return this.$store.getters["users/getUser"](connection.targetUserUUID);
      });
    },
    filterPublicGalleryUser() {
      if (!this.publicTable) return this.userNetworkUsersList;

      return this.userNetworkUsersList.filter(user => {
        return this.publicTable.uuid !== user.tableUUID;
      });
    },
    /** Private chat target user */
    privateChatTargetUser() {
      return this.$store.getters["users/getUser"](this.privateChatTarget.userUUID);
    }
  },
  methods: {
    filterUser(user) {
      this.$store.commit("chat/setPrivateChatTarget", {
        userUUID: user.userUUID,
        firstName: user.firstName,
        lastName: user.lastName,
        domain: user.emailDomain
      });
    },
    clearFilter() {
      this.$store.commit("chat/setPrivateChatTarget", null);
      this.$store.commit("chat/resetUnreadMessagesCounter", CHAT_MODES.PRIVATE);
    }
  }
};
</script>
